export default __webpack_public_path__ + "static/media/Path right.f2cf80b1.svg";